export const radii = {
  none: 0,
  circle: '50%',
};
